export default (context) => {
    context.popup.value = false
    context.overlay = false
}